<template>
  <tbody>
    <tr :class="{'has-bg-lighter':a.no_access}" class="is-border-top">
      <td class="has-text-centered">
        <span class="avatar avatar-01">
          <span class="has-bg-draft"><i class="fas" :class="firstKey === 'company' ? 'fa-building' : 'fa-city'"></i></span>
        </span>
      </td>
      <td>
        <router-link :to="{name: 'CompanyVue', params: {id: a.company}}" v-if="firstKey === 'company'">{{a.company_name | truncate}}</router-link>
        <router-link :to="{name: 'PromoteurVue', params: {id: a.promoteur}}" v-else>{{a.promoteur_name | truncate}}</router-link>
      </td>
      <td>
        <span class="tag is-primary is-size-5" v-if="!a.no_access">
          <span class="icon"><i class="fas fa-check"></i></span>
          <span class="is-size-6">Mandat actif</span>
        </span>
      </td>
      <td v-if="displayRemuneration && !a.no_access" class="is-paddingless is-marginless" style="width: 250px;">
        <div class="field has-addons is-border-left">
          <div class="control has-incrementations">
            <input type="number"
                   class="input is-borderless is-medium has-text-centered"
                   max="100"
                   placeholder="A définir"
                   @focus="selectInput('inputrem')" ref="inputrem"
                   @input="selectEditedRem" put="selectEditedRem"
                   v-model="a.remuneration">
            <div class="incrementation">
              <a  class="incrementation-btn" @click="selectEditedRem(); a.remuneration++"><i class="fas fa-chevron-up"></i></a>
              <a  class="incrementation-btn" @click="selectEditedRem(); a.remuneration--"><i class="fas fa-chevron-down"></i></a>
            </div>
          </div>
          <div class="control">
            <a class="button is-square is-medium is-light is-min-width-0 is-static">
              <span class="icon is-size-5"><i class="fas fa-percentage"></i></span>
            </a>
          </div>
          <div class="control" v-if="!editRem && !loading">
            <a class="button is-square is-medium is-white is-min-width-0" @click="deleteAccess">
              <span class="icon is-size-5"><i class="fas fa-trash"></i></span>
            </a>
          </div>
          <div class="control" v-if="editRem && !loading">
            <a class="button is-square is-medium is-success is-min-width-0 has-hover-black" @click="updateAccess">
              <span class="icon is-size-5"><i class="fas fa-save"></i></span>
            </a>
          </div>
          <div class="control" v-if="editRem && !loading">
            <a class="button is-square is-medium is-draft is-min-width-0" @click="cancelEditAccess">
              <span class="icon is-size-5 has-text-white"><i class="fas fa-times"></i></span>
            </a>
          </div>
          <div class="control" v-if="loading">
            <button class="button is-square is-medium is-primary is-min-width-0 has-hover-black is-loading">
              <span class="icon"><i class="fas fa-lg fa-spinner-third"></i></span>
            </button>
          </div>
        </div>
      </td>
      <td v-else-if="a.no_access && !isSectorManager" class="is-paddingless is-marginless is-pulled-right">
        <div class="field has-addons is-vcentered columns">
          <div class="control" v-if="!loading">
            <a class="button is-square is-medium is-white is-min-width-0 is-border-left"
               @click="addAccess">
              <span class="icon is-size-5"><i class="fas fa-check"></i></span>
            </a>
          </div>
          <div class="control" v-if="loading">
            <button class="button is-square is-medium is-primary is-min-width-0 has-hover-black is-loading">
              <span class="icon"><i class="fas fa-lg fa-spinner-third"></i></span>
            </button>
          </div>
        </div>
      </td>
    </tr>
    <slot></slot>
  </tbody>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { cloneDeep, debounce } from 'lodash'
  import AccessForm from '@/components/access/AccessForm'

  export default {
    name: 'PromoteurAccessItem',
    components: {AccessForm},
    data () {
      return {
        a: null,
        savedAccess: null,
        editRem: false
      }
    },
    props: {
      source: Object,
      program: [Object, String],
      promoteur: [Object, String],
      company: [Object, String],
      loadingAccess: Boolean,
      selectedAccess: String,
      firstKey: {
        type: String,
        default: 'company'
      }
    },
    watch: {
      source (v) {
        this.a = v
        this.savedAccess = cloneDeep(v)
        this.editRem = false
      },
      selectedAccess (v) {
        if (v !== this.a.pk) {
          this.cancelEditAccess()
        }
      }
    },
    computed: {
      ...mapGetters(['displayRemuneration', 'isSectorManager']),
      loading () {
        return this.loadingAccess && this.selectedAccess === this.a.pk
      }
    },
    methods: {
      selectEditedRem: debounce(function () {
        this.editRem = true
        this.$emit('selectedAccess', this.a.pk)
      }, 300),
      updateAccess (a) {
        this.a = Object.assign(this.a, a)
        this.editRem = false
        this.$emit('updateAccess', this.a)
      },
      cancelEditAccess () {
        this.editRem = false
        this.a = cloneDeep(this.savedAccess)
      },
      addAccess () {
        this.$emit('selectedAccess', this.a.pk)
        this.$emit('addAccess', this.a)
      },
      deleteAccess () {
        this.$emit('deleteAccess', this.a.pk)
      },
      askSubmit () {
        this.$refs.accessForm.submit()
      },
      selectInput (input) {
        if (input in this.$refs) {
          if (Array.isArray(this.$refs[input])) {
            this.$refs[input][0].select()
          } else {
            this.$refs[input].select()
          }
        }
      }
    },
    created () {
      if (this.source) {
        this.editRem = false
        this.a = this.source
        this.savedAccess = cloneDeep(this.source)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/promoteur/PromoteurAccessItem.vue